import axios from 'axios'

export class FabService {
  async getFabOffers () {
    console.log(process.env.VUE_APP_FAB_OFFERS_URL)
    return await axios.get(process.env.VUE_APP_FAB_OFFERS_URL).then(r => r.data)
  }
}

export default new FabService()
